var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.windowWidth <= 768)?_c('nav',{staticClass:"flex flex-col pb-12 bg-adminsecondary relative transition-all"},[_c('MainNavBarItems')],1):_c('nav',{staticClass:"flex flex-col pb-12 bg-adminsecondary relative transition-all"},[_c('MainNavBarItems')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }